import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import Part from '../../../components/HomePart'
import './style.scss'

const Confidence: React.FC = () => {
  const { t } = useTranslation('trans', { keyPrefix: 'confidence' })

  return (
    <Part id="confidence" title={t('title')}>
      <div className="description">
        <div>
          <Trans
            t={t}
            i18nKey="description.1"
            components={{ 1: <span className="highlight" /> }}
          />
        </div>
        <div>
          <Trans
            t={t}
            i18nKey="description.2"
            components={{ 1: <span className="highlight" /> }}
          />
        </div>
        <div>
          <Trans
            t={t}
            i18nKey="description.3"
            components={{ 1: <span className="highlight" /> }}
          />
        </div>
      </div>
    </Part>
  )
}

export default Confidence
